import { appStore } from "@store/appStore";
import { GetOrganizationInvoiceParams } from "./cmdGetOrganizationInvoice";

/**
 * The export endpoint STREAMS a CSV with Content-Disposition: attachment, so we
 * can't reuse httpRequest (JSON/text only) — we fetch the blob with the auth
 * header and trigger a browser download via an object URL.
 */
export class CommandExportOrganizationInvoice {
  async run(organizationId: number, params?: GetOrganizationInvoiceParams): Promise<void> {
    const query = new URLSearchParams();
    if (params?.start) query.set("start", params.start);
    if (params?.end) query.set("end", params.end);

    const qs = query.toString();
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/organizations/${organizationId}/invoice/export${qs ? `?${qs}` : ""}`;

    const res = await fetch(url, {
      method: "GET",
      headers: { Authorization: `Token ${appStore.authToken}` },
      cache: "no-store",
    });

    if (!res.ok) {
      const err = await res.json().catch(() => null);
      const message = (err && (err.detail || err.message || err.error)) || res.statusText;
      throw new Error(message);
    }

    const blob = await res.blob();
    const filename =
      filenameFromContentDisposition(res.headers.get("Content-Disposition")) ??
      `invoice-${organizationId}.csv`;

    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(objectUrl);
  }
}

function filenameFromContentDisposition(cd?: string | null): string | null {
  if (!cd) return null;
  const match = /filename\*?=(?:UTF-8''|")?([^";]+)"?/i.exec(cd);
  return match ? decodeURIComponent(match[1].trim()) : null;
}
